import { v4 as uuidv4 } from "uuid";
import cogoToast from "cogo-toast";
const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

export const addToCart = createAsyncThunk(
  "cart/addToCart",
  async ({ product }, { rejectWithValue }) => {
    try {
      const response = await fetch("/api/v1/cart", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          product: {
            type: "SET",
            productId: product.id,
            variationId: product.variationId,
            qty: product.quantity ? product.quantity : 1,
          },
        }),
      });
      const data = await response.json();
      return data;
    } catch(error) {
        console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteFromCart = createAsyncThunk(
  "cart/deleteFromCart",
  async ({ product }, { rejectWithValue }) => {
    try {
      const response = await fetch("/api/v1/cart", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          product: {
            type: "SET",
            productId: product.id,
            variationId: product.variationId,
            qty: 0,
          },
        }),
      });
      const data = await response.json();
      return data;
    } catch(error) {
        return rejectWithValue(error.message);
    }
  }
);

export const decreaseQuantity = createAsyncThunk(
  "cart/decreaseQuantity",
  async ({ product }, { rejectWithValue }) => {
    try {
      const response = await fetch("/api/v1/cart", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          product: {
            type: "SET",
            productId: product.id,
            variationId: product.variationId,
            qty: product.quantity - 1,
          },
        }),
      });
      const data = await response.json();
      return data;
    } catch(error) {
        return rejectWithValue(error.message);
    }
  }
);

export const deleteAllFromCart = createAsyncThunk(
  "cart/deleteAllFromCart",
  async (_,{ rejectWithValue }) => {
    try {
      const response = await fetch("/api/v1/cart/reset-products", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await response.json();
      return data;
    } catch(error) {
        return rejectWithValue(error.message);
    }
  }
);

const CartSlice = createSlice({
  name: "cart",
  initialState: {
    loading: false,
    error: null,
    cartItems: [],
  },
  reducers: {},
  extraReducers: {
    [addToCart.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [addToCart.fullfilled]: (state, action) => {
      const product = action.payload;
      console.log(product);
      if (!product.variation) {
        const cartItem = state.cartItems.find((item) => item.id === product.id);
        if (!cartItem) {
          state.cartItems.push({
            ...product,
            quantity: product.quantity ? product.quantity : 1,
            cartItemId: uuidv4(),
          });
        } else {
          state.cartItems = state.cartItems.map((item) => {
            if (item.cartItemId === cartItem.cartItemId) {
              return {
                ...item,
                quantity: product.quantity
                  ? item.quantity + product.quantity
                  : item.quantity + 1,
              };
            }
            return item;
          });
        }
      } else {
        const cartItem = state.cartItems.find(
          (item) =>
            item.id === product.id &&
            product.selectedProductColor &&
            product.selectedProductColor === item.selectedProductColor &&
            product.selectedProductSize &&
            product.selectedProductSize === item.selectedProductSize &&
            (product.cartItemId ? product.cartItemId === item.cartItemId : true)
        );
        if (!cartItem) {
          state.cartItems.push({
            ...product,
            quantity: product.quantity ? product.quantity : 1,
            cartItemId: uuidv4(),
          });
        } else if (
          cartItem !== undefined &&
          (cartItem.selectedProductColor !== product.selectedProductColor ||
            cartItem.selectedProductSize !== product.selectedProductSize)
        ) {
          state.cartItems = [
            ...state.cartItems,
            {
              ...product,
              quantity: product.quantity ? product.quantity : 1,
              cartItemId: uuidv4(),
            },
          ];
        } else {
          state.cartItems = state.cartItems.map((item) => {
            if (item.cartItemId === cartItem.cartItemId) {
              return {
                ...item,
                quantity: product.quantity
                  ? item.quantity + product.quantity
                  : item.quantity + 1,
                selectedProductColor: product.selectedProductColor,
                selectedProductSize: product.selectedProductSize,
              };
            }
            return item;
          });
        }
      }

      cogoToast.success("Added To Cart", { position: "bottom-left" });
      state.loading = false;
      state.error = null;
    },
    [addToCart.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      console.log(state.error);
      cogoToast.error("Failed To Add To Cart", { position: "bottom-left" });
    },

    [decreaseQuantity.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },
      [decreaseQuantity.fullfilled]: (state, action) => {
        const product = action.payload;
      if (product.quantity === 1) {
        state.cartItems = state.cartItems.filter(
          (item) => item.cartItemId !== product.cartItemId
        );
        cogoToast.error("Removed From Cart", { position: "bottom-left" });
      } else {
        state.cartItems = state.cartItems.map((item) =>
          item.cartItemId === product.cartItemId
            ? { ...item, quantity: item.quantity - 1 }
            : item
        );
        cogoToast.warn("Item Decremented From Cart", {
          position: "bottom-left",
        });
      }
      },
      [decreaseQuantity.rejected]: (state, action) => {
        state.loading = false;
        state.error = null;
        console.log(state.error);

        cogoToast.error("Failed To Decrement From Cart", {
            position: "bottom-left",
          });
      },

      
      [deleteFromCart.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },

      
      [deleteFromCart.fullfilled]: (state, action) => {
        state.cartItems = state.cartItems.filter(
            (item) => item.cartItemId !== action.payload
          );
          cogoToast.error("Removed From Cart", { position: "bottom-left" });
        state.loading = false;
        state.error = null;
      },

      
      [deleteFromCart.rejected]: (state, action) => {
        state.loading = false;
        state.error = action.payload;
        console.log(state.error);
        cogoToast.error("Failed To Remove From Cart", { position: "bottom-left" });

      },

      [deleteAllFromCart.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },

      
      [deleteAllFromCart.fullfilled]: (state, action) => {
        state.cartItems = [];
        state.loading = false;
        state.error = null;
      },

      
      [deleteAllFromCart.rejected]: (state, action) => {
        state.loading = false;
        state.error = action.payload;
        console.log(state.error);
        cogoToast.error("Failed To Clear Shopping Cart", { position: "bottom-left" });
      },
  },
});


export default CartSlice.reducer;
